import { MemberStatus } from '@aibees/shared/definition';
import { useBrowseWorkspaceMembers } from './use-browse-workspace-members';

export function useActiveAndPendingMembersCount() {
  const { browseApi } = useBrowseWorkspaceMembers();

  const members = browseApi.data ?? [];

  const activeAndPendingMembers = members.filter(
    (member) =>
      member?.status === MemberStatus.Active ||
      member?.status === MemberStatus.Pending
  );

  return {
    activeAndPendingMembers,
    activeAndPendingMembersCount: activeAndPendingMembers.length,
  };
}
